var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhiteBlueBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 33,
    viewBox: "0 0 128 33",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.3")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.28 0 0 0.33 64.21 16.56)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(34,35,48)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-50,-50 -50,50 50,50 50,-50 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 64.5 17)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.18 -0.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-51.82, -14.19)",
    d: "M 38.6281 4.92456 H 41.8257 L 46.0481 20.2961 H 46.1145 L 50.2611 4.92456 H 53.3448 L 57.5293 20.2961 H 57.6052 L 61.8276 4.92456 H 65.0158 L 59.0949 23.4558 H 56.0111 L 51.8172 8.16016 H 51.7508 L 47.6422 23.4558 H 44.5584 L 38.6281 4.92456 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.69 -0.3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-72.69, -14.2)",
    d: "M 80.3778 23.4557 H 77.4648 V 21.131 H 77.3889 C 76.2313 22.8769 74.1627 23.9776 71.1074 23.9776 C 67.312 23.9776 64.9968 21.8332 64.9968 18.7019 C 64.9968 14.489 68.128 13.3978 72.9197 12.4964 C 76.0415 11.9081 77.4648 11.5476 77.4648 9.64983 C 77.4648 8.19808 76.6677 6.95508 73.6693 6.95508 C 70.1396 6.95508 68.982 7.97984 68.7922 10.6651 H 65.8887 C 66.069 7.10689 68.2893 4.42163 73.6693 4.42163 C 77.1896 4.42163 80.3113 5.79747 80.3113 10.2666 V 23.4557 H 80.3778 Z M 77.4078 16.3013 V 13.2081 C 76.8575 13.7584 75.0831 14.2613 73.119 14.6598 C 69.5228 15.4284 67.8528 16.3393 67.8528 18.5501 C 67.8528 20.3719 68.944 21.3967 71.3351 21.3967 C 74.8554 21.4252 77.4743 19.8595 77.4743 16.3013 H 77.4078 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 25.68 -2.77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-84.68, -11.73)",
    d: "M 83.2244 0 H 86.1374 V 23.4558 H 83.2244 V 0 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 38.27 -0.23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-97.26, -14.27)",
    d: "M 97.2864 24.044 C 91.5933 24.044 88.1964 20.0493 88.1964 14.2708 C 88.1964 8.49225 91.6122 4.49756 97.2864 4.49756 C 102.961 4.49756 106.329 8.5397 106.329 14.2328 C 106.329 19.926 102.913 24.044 97.2864 24.044 Z M 97.2864 21.5011 C 101.423 21.5011 103.426 18.237 103.426 14.2708 C 103.426 10.3046 101.423 7.0405 97.2864 7.0405 C 93.1494 7.0405 91.1093 10.3141 91.1093 14.2708 C 91.1093 18.2275 93.1019 21.5011 97.2864 21.5011 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.1 -0.56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-113.09, -13.94)",
    d: "M 118 4.52611 V 7.42963 H 117.934 C 113.901 6.77491 111.102 9.612 111.102 13.5687 V 23.4558 H 108.189 V 4.92464 H 111.102 V 8.59672 H 111.168 C 112.117 6.15815 113.645 4.42175 116.292 4.42175 C 116.863 4.41292 117.434 4.44781 118 4.52611 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.85 -0.33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(75,134,188)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-14.15, -14.17)",
    d: "M 28.295 7.82824 V 5.21888 L 20.1158 8.23625 L 23.0667 0.246867 L 23.1427 0.0476074 H 20.5238 L 17.9714 7.81875 L 15.4189 0.151982 V 0.0476074 H 12.9329 L 10.3236 7.81875 L 7.81859 0.151982 V 0.0476074 H 5.18076 L 8.19813 8.24574 L 0.208746 5.2948 L 0 5.21888 V 7.82824 L 7.77115 10.3712 L 0.104375 12.9331 H 0 V 15.3906 L 7.77115 18.0285 L 0.104375 20.5335 H 0 V 23.1428 L 8.19813 20.1254 L 5.25668 28.0959 L 5.18076 28.2951 H 7.79012 L 10.3236 20.5335 L 12.895 28.1907 V 28.2951 H 15.381 L 17.9714 20.5335 L 20.4953 28.1907 V 28.2951 H 23.1142 L 20.1253 20.1634 L 28.0862 23.1049 L 28.295 23.1808 V 20.5714 L 20.5238 18.0285 L 28.1906 15.4666 H 28.295 V 12.9711 L 20.5238 10.3712 L 28.1906 7.8662 L 28.295 7.82824 Z M 25.0973 14.233 L 17.0035 17.0037 L 14.5175 24.1012 L 14.1475 25.1449 L 11.3673 17.0796 L 4.04213 14.5082 L 3.19765 14.233 L 11.2724 11.3865 L 14.119 3.2073 L 16.8897 11.3011 L 23.4463 13.6068 L 25.0973 14.233 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteBlueBg);
export default __webpack_public_path__ + "static/media/logo-white-blue-bg.48c80026cf8dc9a7151828569fcc02d6.svg";
export { ForwardRef as ReactComponent };